export enum RentalItemSortBy {
  A_Z = "a_z",
  Z_A = "z_a",
  PRICE_ASC = "price_asc",
  PRICE_DESC = "price_desc",
}
